import { render } from "./ReportManagement.vue?vue&type=template&id=525ad3f2&scoped=true"
import script from "./ReportManagement.vue?vue&type=script&lang=js"
export * from "./ReportManagement.vue?vue&type=script&lang=js"

import "./ReportManagement.vue?vue&type=style&index=0&id=525ad3f2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-525ad3f2"]])

export default __exports__